import { render, staticRenderFns } from "./Metrological_info.vue?vue&type=template&id=1883945e&"
import script from "./Metrological_info.vue?vue&type=script&lang=js&"
export * from "./Metrological_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports